import { Typogaphy } from 'vnetwork-ui'

interface VersionInfoProps {
    className?: string
    align?: 'left' | 'center' | 'right'
}

const VersionInfo = ({ className = '', align = 'left' }: VersionInfoProps) => {
    const alignmentClass = {
        left: 'text-left',
        center: 'text-center',
        right: 'text-right',
    }[align]

    return (
        <Typogaphy
            size="small"
            className={`text-xs mt-6 text-gray-500 ${alignmentClass} ${className}`}
        >
            Developed by VNETWORK JSC • Build {__APP_VERSION__} ({__APP_ENV__})
        </Typogaphy>
    )
}

export default VersionInfo
